<template>
  <div class="content-box">
    <el-image src="/static/imgs/hq.png" fit="cover" class="saveimg" />
    <div class="hq-box">
      <div class="dis w70">
        <div v-for="(item,index) in box" :key="index" :class="['tapli',tap==index ?'isbgs':'lala']">
          {{item}}
        </div>
      </div>
      <ul class="hq-ul dis" style="flex-wrap: wrap;">
        <li v-for="(item,index) in xwBox" :key="index">
          <router-link style="display: block;" :to="'/market/article/' + item.id">
            {{item.title}}
          </router-link>
        </li>
      </ul>
    </div>

    <pagesK :tootle="total" :page-size="30" @counterchange="counterchange" />
  </div>
</template>

<script>
  import pagesK from '@/components/page'
  export default {
    data() {
      return {
        tap: 0,
        box: ['建筑木方', '建筑模板'],
        total: 0,
        xwBox: [],
      }
    },
    mounted() {
      this.goTop()
      this.getData(1)
    },
    components: {
      pagesK
    },
    methods: {
      counterchange(e) {
        this.getData(e)
        this.goTop()
      },
      getData(page) {
        this.$request('get', this.$otapi + 'items/market?page=' + page + '&limit=30' +
          '&filter={"category": "1","status":"published"}&sort=-date_created&meta=*', {}, (
            res) => {
            if (res.status == 200) {
              this.xwBox = res.data.data
              this.total = res.data.meta.filter_count
            }
          })
      }
    },
    metaInfo() {
      return {
        title: '聚木网-行情资讯'

      }
    }
  }
</script>
<style scoped>
  .hq-box {
    width: 1200px;
    margin: 56px auto 50px auto;
  }

  .w70 {
    width: 700px;
    margin: 0 auto;
  }

  .tapli {
    width: 350px;
    height: 64px;
    text-align: center;
    line-height: 64px;
    background: #FAF9FF;
    color: #37393F;
    font-size: 24px;
    cursor: pointer;
    transition: all .4s;
  }
  .hq-ul{
    margin-top: 30px;
  }



  .hq-ul li {
    width: 48%;
    padding: 20px 0 10px 0;
    font-size: 16px;
    color: #000;
    font-weight: 400;
    border-bottom: 1px solid #C9CDD4;
    cursor: pointer;
  }

  .hq-ul li:hover {
    color: #0093FF;
  }

  .isbgs {
    background: #6B78E5;
    color: #fff;
    border-radius: 12px 0 0 12px;
  }

  .lala {
    border-radius: 0 12px 12px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/market/index.vue